<template>
<!--    <div :class="[showleftarea ? 'w-7/12' : 'w-4/5']">-->
    <div>
        <div class="max-h-80vh overflow-y-auto grid gap-5 rooom-scrollbar" :class="[showleftarea ? 'grid-cols-4' : 'grid-cols-7']">
            <div class="media-item">
                <a href="#" @click.prevent="uploadFile()">
                    <div class="heading">
                        <div>{{ __('media.upload-new') }}</div>
                    </div>
                    <div class="content">
                        <i class="plus-large"></i>
                    </div>
                </a>
            </div>
            <div v-for="file in files" :key="file.id" class="media-item" :class="editableFile && editableFile.id == file.id ? 'active':''">
                <a href="##" @click.prevent>
                    <div class="heading">
                        <div>{{ makeName(file) }}</div>
                    </div>
                    <div class="badge-black">{{ file.extension }}</div>
                    <div class="badge-buttons-wrapper">
                        <div class="badge-buttons">
                            <button @click.prevent="() => select(file)"
                                title="Select"><i class="add"></i></button>

                            <button @click.prevent="editFile(file)"
                                title="Edit"><i class="pen"></i></button>
                        </div>
                    </div>
                    <div class="content">
                        <img v-if="isImage(file)"
                        class="object-cover w-full h-full" :src="isImage(file)">
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>

import { Link } from '@inertiajs/inertia-vue3';
import { __ } from '@/locale'

export default {
    components: { Link },
    props: [
        'showleftarea',
        'select',
        'edit',
        'showModal',
        'fileType',
        'uploadBoxState',
        'resetFileEditable',
        'mediaFilesUpdatedCount',
        'editableFile',
        'provider_id'
    ],
    emits: ['upload:sidebar'],
    data(){
        return{
            __,
            files: [],
            activeFiletype: 'all',
        }
    },
    methods:{
        uploadFile() {
            this.$emit('upload:sidebar', true);
            this.resetFileEditable();
        },
        editFile(file) {
            this.$emit('upload:sidebar', true);
            this.edit(file.id);
        },
        isImage(file){
            const object_type = file.object_type;
            if(object_type == 'file_meta_data_image' || object_type == 'file_meta_data_panorama_image'
                || object_type == 'file_meta_data_marker'){
                return file.path;
            }
            return false
        },
        makeName(file){
            if(file.path.split('/').pop().includes('three'))
            {
                const arr = file.path.split('/');
                return arr[arr.length-2]+'.'+file.extension;
            } else {
                return file.path.split('/').pop();
            }
        },
        getMediaFiles(newActiveFiletype){
            let files = [];

            if(this.provider_id > 0){
                files = this.$page.props.files[this.provider_id].data;
            } else {
                files = this.$page.props.files.data;
            }

            if(this.activeFiletype == 'all'){
              this.files = files;
              return;
            }

            if(newActiveFiletype)
            {
              this.files = files.filter(el => el.object_type.includes('file_meta_data_'+newActiveFiletype))
            }

            //get three dimensional files
            if(newActiveFiletype && newActiveFiletype.includes('three_dimensional_object'))
            {
                if(newActiveFiletype == 'three_dimensional_object_glb'){
                    this.files = files.filter(el => el.object_type
                        .includes('file_meta_data_three_dimensional_object'))
                        .filter(el => el.extension == 'glb');
                }
                if(newActiveFiletype == 'three_dimensional_object_usdz'){
                    this.files = files.filter(el => el.object_type
                        .includes('file_meta_data_three_dimensional_object'))
                        .filter(el => el.extension == 'usdz');
                }
                return;
            }

            if(newActiveFiletype && !newActiveFiletype.includes('three_dimensional_object'))
            {
                this.files = files.filter(el => el.object_type.includes('file_meta_data_'+this.activeFiletype))
            }
        },
        changeActiveFileType(type){
          this.activeFiletype = type;
        }
    },
    watch:{
        showModal: function(newState, oldState){
          if(newState == true)
          {
            this.getMediaFiles(this.activeFiletype);
            if(this.fileType){
              this.activeFiletype = this.fileType;
              this.getMediaFiles(this.fileType);
            }
          }
        },
        activeFiletype: function(newState, oldState){
          this.getMediaFiles()
        },
        mediaFilesUpdatedCount: function(newState, oldState){
            this.getMediaFiles(this.fileType);
        }
    }
}
</script>
